// extracted by mini-css-extract-plugin
export default {"divider":"RcP1OjSxro70buPlTvUJ"};